import AppBar from "@mui/material/AppBar";
import IconButton from "@mui/material/IconButton";
import Toolbar from "@mui/material/Toolbar";
import MenuIcon from "@mui/icons-material/Menu";
import { ReactNode } from "react";
import { useLocation } from "react-router";
import { useTranslation } from "react-i18next";
import { MenuOptionsConfig } from "./MenuOptions";
import { useMobileNavigation } from "../../contexts/MobileNavigationContext";
import "./TopAppBar.scss";

export const TopAppBar = (props: TopAppBarProps) => {
  const location = useLocation();
  const mobileNavigation = useMobileNavigation();
  const { t } = useTranslation();
  const currentOption = MenuOptionsConfig.find(
    (option) => option.path?.toLowerCase() === location.pathname.toLowerCase(),
  );

  return (
    <AppBar position="sticky" className="mobile-top-app-bar" elevation={1}>
      <Toolbar className="mobile-top-app-bar__toolbar">
        <IconButton
          edge="start"
          color="inherit"
          aria-label="Open navigation menu"
          className="burger-menu-icon"
          onClick={props.onMenuClick}
        >
          <MenuIcon />
        </IconButton>
        <span className="mobile-top-app-bar__title">
          {mobileNavigation?.title ??
            (currentOption ? t(currentOption.textKey) : "Admin Panel")}
        </span>
        {props.actions && (
          <div className="mobile-top-app-bar__actions">{props.actions}</div>
        )}
      </Toolbar>
    </AppBar>
  );
};

interface TopAppBarProps {
  onMenuClick: () => void;
  actions?: ReactNode;
}
